export default "__VITE_ASSET__eoQt7Etx__"